import React from "react"
import WineboxBottom
  from "@bodeboca/algolia/components/wineblock/winebox_bottom"
import PriceBoxRight
  from "@bodeboca/algolia/components/wineblock/pricebox-right"
import SizePrice from "@bodeboca/algolia/components/wineblock/size-price"
import CommonUtils from "@bodeboca/utils"

const Pricebox = ({hit, sendEvent, userFlaggedItems, availableBundlesToFlag}) => {
  const role = CommonUtils.getRole()
  const showPvp = hit["pvp"] > 0 && hit["show_pvp"]
  const hasDiscount = hit["collection_discount"] > 0

  return (<div className="wineblock-pricebox">
    <div className="wineblock-pricebox-inner">
      <div className="wineblock-pricerow">
        <div className="pricebox">
          <div className="pricebox-part1">
            <div className="price radiocanadabig">
              <SizePrice
                price={hit['price']}
                strikethrough={!showPvp && hasDiscount}/>
            </div>
          </div>
          <PriceBoxRight hit={hit}/>
        </div>
        <WineboxBottom
          availableBundlesToFlag={availableBundlesToFlag}
          hit={hit}
          sendEvent={sendEvent}
          userFlaggedItems={userFlaggedItems}/>
      </div>
    </div>
  </div>)
}
export default Pricebox
